export default __webpack_public_path__ + "static/media/tabActMine.bab427a2.svg";